<template>
    <div class="gas_content">
      <div class="topImgContent">
        <div class="topImgTitleContent">
          <div class="topImgTitle">政务服务</div>
          <div class="topImgsubTitle">FUTURE SCIENCE CITY NEWS</div>
        </div>
      </div>
      <div class="commonTabContent e-flex" style="background: #f5f5f5;">
        <div class="commonTabCenter e-flex">
          <div v-for="(item, index) in tabs" :class="'commonTab ' + (index == tabIndex ? 'commonTabActive' : '')" @click="changeTab(item, index)">{{ item.name }}</div>
        </div>
      </div>
      <div class="e-flex" style="justify-content: center;background: #fff;">
        <div class="gas_classifyContent e-flex">
            <div v-for="(item, index) in classifyList" :class="'gas_classifyList ' + (index == classifyIndex ? 'gas_classifyListActive' : '')" @click="changeClassify(item, index)">{{ item.name }}</div>
        </div>
      </div>
      <div class="gas_listContent" style="justify-content: center;">
        <div class="e-flex gas_list" v-for="(item, index) in list" v-if="index % 5 == 0">
            <div class="gas_listBlock e-flex gas_listBlock_ml0" @click="goDetail(item.id)">
                <div class="gas_listBlockNameText">{{ item.title.slice(0,19) }}</div>
                <!-- <img class="gas_listBlockImg" src="@/assets/images/demo/demo2.png">
                <div class="e-line-1 gas_listBlockText">{{ item.title }}</div> -->
            </div>
            <div class="gas_listBlock e-flex" v-if="list[index + 1]" @click="goDetail(list[index + 1].id)">
              <div class="gas_listBlockNameText">{{ list[index + 1].title.slice(0,20) }}</div>
                <!-- <img class="gas_listBlockImg" src="@/assets/images/demo/demo2.png">
                <div class="e-line-1 gas_listBlockText">{{ list[index + 1].title }}</div> -->
            </div>
            <div class="gas_listBlock e-flex" v-if="list[index + 2]" @click="goDetail(list[index + 2].id)">
              <div class="gas_listBlockNameText">{{ list[index + 2].title.slice(0,20) }}</div>
                <!-- <img class="gas_listBlockImg" src="@/assets/images/demo/demo2.png">
                <div class="e-line-1 gas_listBlockText">{{ list[index + 2].title }}</div> -->
            </div>
            <div class="gas_listBlock e-flex" v-if="list[index + 3]" @click="goDetail(list[index + 3].id)">
              <div class="gas_listBlockNameText">{{ list[index + 3].title.slice(0,20) }}</div>
                <!-- <img class="gas_listBlockImg" src="@/assets/images/demo/demo2.png">
                <div class="e-line-1 gas_listBlockText">{{ list[index + 3].title }}</div> -->
            </div>
            <div class="gas_listBlock e-flex" v-if="list[index + 4]" @click="goDetail(list[index + 4].id)">
              <div class="gas_listBlockNameText">{{ list[index + 4].title.slice(0,20) }}</div>
                <!-- <img class="gas_listBlockImg" src="@/assets/images/demo/demo2.png">
                <div class="e-line-1 gas_listBlockText">{{ list[index + 4].title }}</div> -->
            </div>
        </div>
      </div>
      <div class="noDataContent" v-if="list.length == 0">
        <img class="noDataImg" src="@/assets/images/noDataImg.png">
        <div class="noDataText">暂无内容</div>
      </div>
    </div>
  </template>
  
  <script>
    import '../../styles/governmentAffairsService.css'
    export default {
      name: 'governmentAffairsService',
      data () {
        return {
          tabs: [{
            name: '全部分类',
            id: ''
          }],
          tabIndex: 0,
          classifyList: [],
          classifyIndex: 0,
          list: [],
          defaultId: ''
        }
      },
      created() {
        // this.defaultId = parseInt(this.$route.query.id)
        // this.tabIndex = this.defaultId ? this.defaultId : this.tabIndex
        this.getCategory()
      },
      methods: {
        changeTab(item, index) {
          this.tabIndex = index
          this.classifyList = item.subCategories ? item.subCategories : []
          this.classifyIndex = 0
          this.getList()
        },
        goDetail(id) {
          this.$router.push({ path: '/governmentAffairsService/governmentAffairsServiceDetail', query: {id: id}})
        },
        changeClassify(item, index) {
            this.classifyIndex = index
            this.getList()
        },
        getCategory() {
          this.request({
              url: 'governmentService/queryCategoryAllList',
              method: 'POST',
              data: {}
          }).then(res => {
              this.tabs = this.tabs.concat(res.data)
              if (this.$route.query.id !== '') {
                this.tabs.forEach((item, index, array) => {
                  if (item.id == this.$route.query.id) {
                    this.tabIndex = index
                  }
                })
                this.classifyList = this.tabs[this.tabIndex].subCategories ? this.tabs[this.tabIndex].subCategories : []
              }
              this.getList()
          })
        },
        getList() {
          let categoryId = this.tabs[this.tabIndex] ? this.tabs[this.tabIndex].id : ''
          let subCategoryId = this.classifyList[this.classifyIndex] ? this.classifyList[this.classifyIndex].id : ''
          this.request({
              url: 'governmentService/list',
              method: 'POST',
              data: {
                categoryId: categoryId,
                subCategoryId: subCategoryId,
                page: 1,
                limit: 10000,
                status: 1
              }
          }).then(res => {
              this.list = res.data
          })
        }
      }
    }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  
  </style>
  


// WEBPACK FOOTER //
// src/view/governmentAffairsService/index.vue